<template>
  <div class="setup-hub-completed-sub-step-footer">
    <div class="setup-hub-completed-sub-step-footer--status">
      <v-icon :icon="iconName" :size="20" :color="iconColor" class="mr-2" />
      <span class="setup-hub-completed-sub-step-footer--status-text">{{ statusText }}</span>
    </div>
    <v-btn
      rounded
      size="default"
      variant="outlined"
      color="primary"
      class="setup-hub-completed-sub-step-footer--button"
      @click="$emit('start-new-task-click')"
    >
      {{ $t("setupHub.startNextTask") }}
      <v-icon icon="$chevronRight" size="16" class="ml-1" />
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, type PropType } from "vue";
import { SetupHubStatus } from "@/constants/setup-hub.ts";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    status: {
      type: String as PropType<SetupHubStatus>,
      required: true,
    },
  },
  emits: ["start-new-task-click"],
  setup(props) {
    const i18n = useI18n();

    const statusText = computed(() => {
      if (props.status === SetupHubStatus.COMPLETED) {
        return i18n.t("setupHub.completed");
      }
      if (props.status === SetupHubStatus.SKIPPED) {
        return i18n.t("setupHub.skipped");
      }
      return "";
    });

    const iconName = computed(() => {
      if (props.status === SetupHubStatus.COMPLETED) {
        return "icon-success-xs";
      }
      return "icon-skip-xs";
    });

    const iconColor = computed(() => {
      if (props.status === SetupHubStatus.COMPLETED) {
        return "green-base";
      }
      return "";
    });

    return {
      statusText,
      iconName,
      iconColor,
    };
  },
});
</script>

<style lang="scss" scoped>
.setup-hub-completed-sub-step-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-right: 15px;
  margin-left: 15px;
  &--status {
    display: flex;
    align-items: center;
    &-text {
      color: rgb(var(--v-theme-primary));
      font-weight: 600;
      font-size: 14px;
      line-height: 130%;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }
  &--button {
    background-color: white !important;
    color: rgb(var(--v-theme-primary)) !important;
    border-color: rgb(var(--v-theme-primary)) !important;
  }
}
</style>
